import { useEffect, useState } from "react";

import { config } from "@/config";
import { fetchWithAuth } from "@/features/auth/auth.utils";

export const useRole = () => {
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const checkAdminRole = async () => {
            const response = await fetchWithAuth(`${config.API_BASE_URL}user/is-admin`);
            const data: boolean = await response.json();

            setIsAdmin(data);
        };

        checkAdminRole();
    }, []);

    return { isAdmin };
};
